import { render, staticRenderFns } from "./DialogHistoryVars.vue?vue&type=template&id=65bb6241"
import script from "./DialogHistoryVars.vue?vue&type=script&lang=js"
export * from "./DialogHistoryVars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports